import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import OrderToolbar from "../components/OrderToolbar";
import NeedPanel from "../components/NeedPanel";
import PackPanel from "../components/PackPanel";
import OrderForm from "../components/OrderForm";
import ProjectResume from "../components/ProjectResume";
import NewProjectContextProvider from "../context/NewProjectContext";

const StartProject = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = "Démarrer un projet";
  }, []);

  return (
    <NewProjectContextProvider>
      <React.Fragment>
        <OrderToolbar />
        {pathname === "/newproject" ? (
          <NeedPanel />
        ) : pathname === "/newproject/pack" ? (
          <PackPanel />
        ) : pathname === "/newproject/order" ? (
          <OrderForm />
        ) : (
          <ProjectResume />
        )}
      </React.Fragment>
    </NewProjectContextProvider>

  );
};

export default StartProject;
